import { $t } from '@/i18n';
/* eslint-disable no-param-reassign */
import { cloneDeep } from 'lodash';
import getUICoreConfig, { getMethods } from '@/components/pagelet-component/get-ui-core-config';
import xyPageContainer from '@/components/pagelet-component/index';
import dataSourceSelector from '@/components/pagelet-component/props-panel/form-item/data';
import { HIDDEN_GROUP } from '@/pages/project/pageConfig/pagelet-component-editor/composable/use-props-schema';

const getJumpToEditorAction = (projectId, materialId) => () => [
  {
    title: $t('k_b48da60b'),
    icon: 'fa fa-link',
    desc: $t('k_50037619'),
    execute() {
      window.open(`/xy/project/editor/component?projectid=${projectId}&materialid=${materialId}`, 'blank');
    },
  },
];

export const getCompInfo = (extraInfo, name, category, icon) => {
  const { propsSchema, bindings, fitData } = getUICoreConfig(extraInfo.pageletPropSchemas, extraInfo.fitData);
  const methods = getMethods(extraInfo.methods) || [];

  const configKeys = ['projectId', 'pagelets', 'pageletPropSchemas', 'events', 'slots', 'exposedMethods'];
  configKeys.forEach((key) => {
    const field = propsSchema.fields.find(field => field.id === key);
    if (field) {
      if (key === 'pageletPropSchemas') {
        field.default = extraInfo.pageletPropSchemas.filter(group => group.id !== HIDDEN_GROUP);
        return;
      }
      if (key === 'slots') {
        field.default = extraInfo.slots || [];
        return;
      }
      if (key === 'exposedMethods') {
        field.default = methods.map(method => method.id);
        return;
      }
      field.default = extraInfo[key];
    }
  });

  const props = {};
  propsSchema.fields.forEach((field) => {
    const fieldConfig = { required: false };

    const defaultVal = field.default;
    if (defaultVal !== undefined) {
      fieldConfig.default = typeof defaultVal === 'object' ? () => cloneDeep(defaultVal) : defaultVal;
    }
    props[field.id] = fieldConfig;
  });
  const comp = xyPageContainer.component.extend({
    props,
  });

  return {
    comp,
    config: {
      ...xyPageContainer,
      category,
      icon,
      propPanel: {
        dataSourceSelector: {
          component: dataSourceSelector,
        },
      },
      propsSchema,
      slots: extraInfo.slots,
      name,
      events: extraInfo.events,
      fitData,
      methods,
      bindings,
      getActions: getJumpToEditorAction(extraInfo.projectId, extraInfo.materialId),
    },
  };
};


const moduleLoader = async (module, _, extraInfo) => {
  const compInfo = getCompInfo(extraInfo, module.compDB.name, module.compDB.category.name, module.compDB.icon);

  module.setCompInfo(compInfo);
  module.lazyLoad = false; // 在线组件不支持懒加载
  module.compDependencies = extraInfo.compDependencies || [];
};

export default moduleLoader;
